import SleepEfficencyScoreSection from './SleepEfficencyScoreSection'

export default SleepEfficencyScoreSection
